import React from 'react';
import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (e) => {
    const selectedLang = e.target.value;
    i18n.changeLanguage(selectedLang);
  };

  return (
    <Form.Select
      
      value={i18n.language}
      onChange={handleLanguageChange}
      style={{ width: '70px', height: '55px' }} // même hauteur que les boutons
      
    >
      <option value="fr">FR</option>
      <option value="en">EN</option>
    </Form.Select>
  );
};

export default LanguageSelector;
